import styled, { keyframes, css } from 'styled-components';
import { useThemeContext } from '../../../styles/themes/themes.js';
import { ProgressBarStatus } from '../types.js';
import { jsx } from 'react/jsx-runtime';

var StyledBarContainer = styled.div.withConfig({
  displayName: "LateralBar__StyledBarContainer",
  componentId: "sc-1ccn4di-0"
})(["&&{transition:all 1s ease-out;position:relative;height:8px;border-radius:4px;overflow:hidden;background-color:", ";min-width:80px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.neutralColors.silver;
});
var indeterminateAnim = keyframes(["0%{width:25%;left:-35%;}25%{width:25%;}50%{width:50%;}100%{width:25%;left:100%;}"]);
var StyledBar = styled.div.withConfig({
  displayName: "LateralBar__StyledBar",
  componentId: "sc-1ccn4di-1"
})(["&&{position:absolute;top:0;left:0;height:100%;transition:all 1s ease-out;background-color:", ";width:", ";", ";}"], function (props) {
  return props.barBackgroundColor;
}, function (props) {
  return props.barLength;
}, function (props) {
  return props.isIndeterminate ? css(["animation:", " 1.5s linear infinite;"], indeterminateAnim) : void 0;
});
var LateralBar = function LateralBar(_ref2) {
  var status = _ref2.status,
    valuePercentage = _ref2.valuePercentage;
  var theme = useThemeContext();
  var barLength;
  var barBackgroundColor;
  switch (status) {
    case ProgressBarStatus.error:
      barBackgroundColor = theme.alertColors.error;
      barLength = "100%";
      break;
    case ProgressBarStatus.success:
      barBackgroundColor = theme.alertColors.success;
      barLength = "100%";
      break;
    case ProgressBarStatus.indeterminate:
      barBackgroundColor = theme.alertColors.information;
      barLength = "10%";
      break;
    case ProgressBarStatus.progress:
      barBackgroundColor = theme.alertColors.information;
      barLength = "".concat(valuePercentage, "%");
      break;
  }
  return /*#__PURE__*/jsx(StyledBarContainer, {
    children: /*#__PURE__*/jsx(StyledBar, {
      barLength: barLength,
      barBackgroundColor: barBackgroundColor,
      isIndeterminate: status === ProgressBarStatus.indeterminate
    })
  });
};
LateralBar.displayName = "LateralBar";

export { LateralBar };
